import { Outlet } from 'react-router'

import { ProjectProvider } from '@/contexts/project'

import { ProjectParamRouteGuard } from '../guards/project-param'

export function ProjectRoutesWrapper() {
  return (
    <ProjectParamRouteGuard>
      <ProjectProvider>
        <Outlet />
      </ProjectProvider>
    </ProjectParamRouteGuard>
  )
}
